import type { FieldSchema } from '@/stores'
import { SelectInput } from './inputs'
import type { SelectOption } from './inputs/types'

export interface SelectFieldsetProps {
  schema: FieldSchema
  getUniqueValues?: (field: string) => SelectOption[]
  selectedValues: string[]
  setSelectedValues: (values: string[]) => void
}

export function SelectFieldset({
  schema,
  getUniqueValues,
  selectedValues,
  setSelectedValues,
}: SelectFieldsetProps) {
  const options = getUniqueValues ? getUniqueValues(schema.field) : []

  return (
    <SelectInput
      label={`Select ${schema.label}`}
      options={options}
      value={selectedValues}
      onChange={setSelectedValues}
      multiple={schema.multiple !== false}
      emptyMessage={`No ${schema.label}s available`}
    />
  )
}
